{
  "hero": {
    "variants": [
      "centered",
      "split",
      "portrait_split",
      "portrait_bg",
      "fullwidth_image"
    ],
    "primary": "centered"
  },
  "features_grid": {
    "variants": [
      "cards_3col",
      "cards_4col",
      "alternating_2col",
      "icon_list",
      "compact_strip"
    ],
    "primary": "cards_3col"
  },
  "gallery": {
    "variants": [
      "grid_3col",
      "grid_2col",
      "grid_4col",
      "asymmetric_2col",
      "mosaic"
    ],
    "primary": "grid_3col"
  },
  "footer": {
    "variants": [
      "attribution",
      "multi_column"
    ],
    "primary": "attribution"
  },
  "header": {
    "variants": [
      "nav_only",
      "minimal"
    ],
    "primary": "nav_only"
  },
  "contact": {
    "variants": [
      "columns_map",
      "stacked"
    ],
    "primary": "columns_map"
  },
  "blog": {
    "variants": [
      "latest_posts_strip"
    ],
    "primary": "latest_posts_strip"
  },
  "team": {
    "variants": [
      "grid",
      "side_by_side"
    ],
    "primary": "grid"
  },
  "testimonials": {
    "variants": [
      "grid_cards",
      "single_highlight"
    ],
    "primary": "grid_cards"
  },
  "pricing": {
    "variants": [
      "cards_3col",
      "comparison_table"
    ],
    "primary": "cards_3col"
  },
  "process": {
    "variants": [
      "numbered_steps",
      "timeline"
    ],
    "primary": "numbered_steps"
  },
  "cta": {
    "variants": [
      "centered",
      "split"
    ],
    "primary": "centered"
  },
  "faq": {
    "variants": [
      "stacked"
    ],
    "primary": "stacked"
  },
  "hours": {
    "variants": [
      "list",
      "table"
    ],
    "primary": "list"
  },
  "menu_card": {
    "variants": [
      "item_list"
    ],
    "primary": "item_list"
  },
  "portfolio": {
    "variants": [
      "project_grid"
    ],
    "primary": "project_grid"
  },
  "stats_strip": {
    "variants": [
      "horizontal"
    ],
    "primary": "horizontal"
  },
  "logo_cloud": {
    "variants": [
      "horizontal"
    ],
    "primary": "horizontal"
  },
  "custom": {
    "variants": [
      "freeform"
    ],
    "primary": "freeform"
  }
}
